import React from 'react'
import styled, { keyframes } from 'styled-components'
import { ReactComponent as Lounge } from '../../assets/lounge.svg'

const pulse = keyframes`
  0% {
    -webkit-transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(0.75);
  }
  100% {
    -webkit-transform: scale(1);
  }
`

const Throbber = props => {
  const Container = styled.div`
    width: 60px;
    height: 60px;
    position: relative;
    animation: ${pulse} 1.5s;
    animation-timing-function: cubic-bezier(0.5, 0.05, 0.5, 0.5);
    animation-iteration-count: infinite;
  `
  return (
    <Container>
      <Lounge />
    </Container>
  )
}

export default Throbber
